// Adding Flatpickr for date inputs
import flatpickr from "flatpickr";

const initFlatpickr = () => {
  flatpickr(".datepicker", {});
};

export { initFlatpickr };


document.addEventListener('turbo:load', () => {
  // Call your functions here, e.g:
  initFlatpickr();
});